// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3ux1U{padding-top:100px}._1GEFh{background-color:#fff}._1GEFh a{color:#ff5349}._1GEFh a:hover{color:#94302a}", ""]);
// Exports
exports.locals = {
	"root": "_3ux1U",
	"specialtyContainer": "_1GEFh"
};
module.exports = exports;
